import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Main from "./components/Main/Main";
import { Helmet } from "react-helmet-async";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import LoadingScreen from "./components/Loading/Loading";
import { useEffect } from "react";
import {
  fetchAllowedCountries,
  fetchCurrencyOptions,
  fetchExchangeRates,
  updateExchangeRates,
} from "./redux/slices/countriesSlice";
import { generateExchangeRates } from "./hooks/generateExchangeRates";
import CatchAllRedirect from "./hooks/CatchAllRedirect";
import NotFound from "./pages/NotFound/NotFound";
import KycSuccess from "./components/Success/Success";
import InstallPWA from "./components/InstallPWA/InstallPWA";
import CookiesConsent from "./components/CookiesConsent/CookiesConsent";
import WhatsAppButton from "./components/WhatsAppButton/WhatsAppButton";
import useTracking from "./hooks/useTracking";
import TrackingScripts from "./components/TrackingScripts/TrackingScripts";
import { isStaging } from "./utils/env";

function App() {
  const isLoading = useSelector((state) => state.loading.isLoading);
  // const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const conversionRates = useSelector((state) => state.country.conversionRates);
  const currencyOptions = useSelector((state) => state.country.currencyOptions);

  // useAutoLogout(logout, token, navigate, dispatch);
  useTracking();

  useEffect(() => {
    dispatch(fetchExchangeRates());
    dispatch(fetchCurrencyOptions());
    dispatch(fetchAllowedCountries());
  }, [dispatch]);

  useEffect(() => {
    if (conversionRates.length > 0 && currencyOptions.length > 0) {
      const updatedRates = generateExchangeRates(
        conversionRates,
        currencyOptions,
      );
      dispatch(updateExchangeRates(updatedRates));
    }
  }, [conversionRates, currencyOptions, dispatch]);

  const maintenance = process.env.REACT_APP_ENVIRONMENT == "maintenance";

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
      <div className="App">
        <TrackingScripts />
        {isLoading && <LoadingScreen />}
        <InstallPWA />
        <Helmet>
          <title>
            {" "}
            Cardplot | Seamless Cross-Border Payments & Global Financial
            Connectivity Across Africa{" "}
          </title>
          <meta
            name="description"
            content="Cardplot is a fintech platform enabling secure cross-border payments, digital wallets, and global financial connectivity for Africans and businesses operating across international markets."
          />
          <meta
            name="keywords"
            content="Pan-African payments App, African money transfer, mobile money transfers in East Africa, mobile money transfers in West Africa, mobile money transfers in Central Africa, mobile money transfers in North Africa, mobile money transfers in South Africa, move money with african currencies, mobile money, African fiat currencies remittances, Cardplot Africa payments, Cardplot fintech, secure cross-border payments for Africans, best fintech platform for sending & receiving money in Africa, fintech, cross-border payments, 
                                           African financial corridors, remittances, digital wallets, African payments, pan-African transfers, multi-currency digital wallet for African users, borderless payments for Africans, 
                                           best fintech platform in Africa, best fintech platform for Africans, best fintech platform for businesses in Africa, best fintech platform for sending & receiving money in Africa, 
                                           multi-currency digital wallet for African users, pan-african payment settlement system, pan-african payment gateway, pan-african payment processing, pan-african payment integration, pan-african payment solution, pan-african payment platform, pan-african payment system, pan-african payment technology, pan-african payment infrastructure, pan-african payment solution for businesses in Africa"
          />

          <meta charSet="utf-8" />
          <meta name="robots" content={process.env.REACT_APP_ROBOTS || (isStaging ? "noindex, nofollow" : "index, follow")} />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
        </Helmet>

        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          closeOnClick={true}
          pauseOnHover={true}
          draggable={true}
        />
        <CookiesConsent />
        <WhatsAppButton />

        {maintenance ? (
          <Routes>
            <Route path="/*" element={<Main />} />
            {/* Catch-all redirect */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        ) : (
          <Routes>
            <Route path="/*" element={<Main />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        )}
      </div>
    </GoogleOAuthProvider>
  );
}

export default App;
